export default "/images/search.svg?0bd4f2bd3674196f4c6ee55a4796b844";